module.exports = __webpack_public_path__ + "img/Upmood Illustration_2_x1.157fb884.png";